var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChatAvatar = function SvgChatAvatar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 130,
    height: 135,
    viewBox: "0 0 130 135"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "a",
    cx: 64.262,
    cy: 64.262,
    r: 64.262
  }), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    fillRule: "evenodd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.738 6.475)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    fill: "#8b688d",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 156.465 4.468)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffb8b8",
    d: "M141.346 102.273a5.643 5.643 0 0 0-4.23-.288c-1.389.458-2.478 1.432-2.977 2.663-1.735 4.203-3.493 12.967-2.867 31.187 1.153 33.508 1.729 56.354 1.729 56.354v50.77s-25.354 48.738-11.525 48.738c13.83 0 23.626-38.585 23.626-38.585s12.677-58.385 8.643-68.538c0 0 11.374-70.147-12.4-82.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.614,
    cy: 48.618,
    r: 41.91,
    fill: "#322c3a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffb8b8",
    d: "M85.25 83.942c2.536 3.546 5.33 11.547 3.394 12.516s-13.06 1.454-19.831 9.694c-6.772 8.24 8.223 29.08 8.223 29.08l57.077-38.29-23.218-7.754s-7.558-11.803-7.074-21.012z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M85.25 83.942c2.536 3.546 5.33 11.547 3.394 12.516s-13.06 1.454-19.831 9.694c-6.772 8.24 8.223 29.08 8.223 29.08l57.077-38.29-23.218-7.754s-7.558-11.803-7.074-21.012z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 86.614,
    cy: 59.794,
    r: 25.146,
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 81.026,
    cy: 37.442,
    fill: "#322c3a",
    rx: 19.558,
    ry: 13.97
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 111.472,
    cy: 51.566,
    fill: "#ffb8b8",
    rx: 1.732,
    ry: 3.978,
    transform: "rotate(-13.434 111.472 51.566)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6a6a7c",
    d: "M103.624 10.728c7.887-8.405 21.141-9.582 30.489-2.708-.427-.439-.87-.868-1.342-1.278-9.266-8.067-22.522-8.088-30.895.839-8.374 8.926-10.815 21.184-2.786 30.047.417.46.959.793 1.455 1.158-8.035-8.274-4.805-19.651 3.08-28.058z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6a6a7c",
    d: "M118.938 17.333c11.282-2.36 5.734-8.575-5.505-6.22-11.98 2.508-16.998 13.812-14.047 25.737.15.607.74 1.118.937 1.701-1.837-11.386 7.335-18.853 18.615-21.218z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008689",
    d: "m144.608 98.536-16.737-5.88s-3.975-1.2-5.75.312c-2.286 1.945-3.818 7.04-7.709 10.917s-7.23 7.818-13.153 7.84c-6.277.023-8.896-1.081-12.183-4.746-3.876-4.32-2.978-10.933-5.544-9.915-12.824 5.087-16.524 7.369-20.428 10.762-2.158 1.874-4.241 3.75-5.133 9.921-1.35 9.349 6.892 18.024 6.892 18.024s-9.352 6.37-4.922 21.068c4.43 14.698 14.275 15.188 12.798 17.148s-1.969 13.718-1.969 13.718S-6.02 304.801.38 392.01c0 0 67.93 45.565 77.283 16.168 9.353-29.396 12.306-106.317 12.306-106.317s8.368 120.526 28.058 120.036c19.69-.49 64.485-6.86 60.547-22.048-3.938-15.188-35.934-77.9-32.488-122.485s-23.628-83.29-23.628-83.29 5.907-12.248 2.953-14.208l32.489-48.994s0-27.927-13.291-32.336z"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "#322c3a",
    transform: "translate(-5 -5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.459 41.223c-10.142-.001-18.591-8.444-19.435-19.42-.045.583-.073 1.17-.073 1.766 0 11.7 8.734 21.185 19.508 21.185S61.967 35.27 61.967 23.57c0-.595-.028-1.183-.072-1.766-.845 10.976-9.294 19.419-19.436 19.42z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47.049,
    cy: 25.246,
    r: 19.508
  })))));
};
export default SvgChatAvatar;